const state = {
  errors: {},
  type: [
    {
      id: 1,
      name: "こってり"
    }
  ]
};
const getters = {
  type(state) {
    return state.type;
  }
};

const actions = {};

const mutations = {};

export default {
  state,
  actions,
  mutations,
  getters
};
